<template>
    <div
        :class="heightClass"
        class="pt-6 flex flex-col"
        data-cy="quick-filters-modal"
    >
        <IonHeader class="ion-no-border">
            <ModalHeader
                class="border-b border-transparent transition-colors duration-150"
                :class="{ 'border-gray-300!': scrollY > 0 }"
                @close="onCancelled"
            >
                {{ title || $t('inline-switcher.modal.title') }}
            </ModalHeader>
        </IonHeader>
        <IonContent
            ref="contentScroll"
            class="flex-1"
            scroll-events
            @ion-scroll="onScroll"
        >
            <div class="pb-(--beyond-safe-area-inset-bottom)">
                <DForm class="p-4">
                    <DField>
                        <DRadio
                            v-for="user in allUsers"
                            :key="user.external_id"
                            v-model="selected"
                            card
                            :native-value="user.external_id"
                            radio-position="right"
                        >
                            <template #icon>
                                <UIAvatar
                                    :avatar="user.avatar"
                                    size-override="medium-small"
                                />
                            </template>
                            {{ user.name }}
                        </DRadio>
                    </DField>
                </DForm>
            </div>
        </IonContent>
    </div>
</template>
<script setup>
    import {
        DForm, DField, DRadio,
    } from '@digistorm/spark'
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const props = defineProps({
        active: Object,
        users: Array,
        onSelected: Function,
        onCancelled: Function,
        title: String,
    })

    const selected = ref(null)
    const scrollY = ref(0)

    const allUsers = computed(() => {
        return props.users
    })

    const heightClass = computed(() => {
        if (allUsers.value.length >= 5) {
            // Ionic modal provides --max-height
            return 'h-(--max-height)'
        }
        if (allUsers.value.length >= 4) {
            return 'h-[28rem]'
        }
        if (allUsers.value.length >= 3) {
            return 'h-[23rem]'
        }
        return 'h-[18rem]'
    })

    const onScroll = (e) => {
        scrollY.value = e.detail.scrollTop
    }

    watch(() => props.active?.external_id, (id) => {
        selected.value = id
    }, { immediate: true })

    watch(() => selected.value, (value) => {
        if (value === props.active?.external_id) {
            return
        }
        props.onSelected(props.users.find((user) => user.external_id === value))
    })
</script>
